import { useTranslation } from "react-i18next"
import { AuthenticationFactorType } from "../../../@client/Theasoft_DataTypes_Enums"

export default function useGetLocalizedAuthenticationFactorType() {
  const { t } = useTranslation("app_server")

  return (authenticationFactorType: AuthenticationFactorType) => {
    switch (authenticationFactorType) {
      case "AuthenticatorApp":
        return t("AuthenticationFactorType_AuthenticatorApp")
      case "Email":
        return t("AuthenticationFactorType_Email")
      default:
        return authenticationFactorType
    }
  }
}
